// Créditos de áudio (espelho do CREDITS.md, mostrado na tela Sobre).
export interface AudioCredit {
  use: string;
  work: string;
  author: string | null;
  url: string | null;
}

/** Trilha original, composta e sintetizada por scripts/compose-music.py. */
export const MUSIC_CREDIT = 'Trilha original do Estandarte, composta e sintetizada por código (scripts/compose-music.py).';

/** Gravações CC0 usadas quando os arquivos estão em public/audio/ (veja scripts/prepare-audio.sh). */
export const AUDIO_CREDITS: AudioCredit[] = [
  { use: 'Dados', work: 'Casino Audio', author: 'Kenney', url: 'https://kenney.nl/assets/casino-audio' },
  { use: 'Choque de espadas', work: 'Sword Clashes', author: 'StarNinjas', url: 'https://opengameart.org/content/sword-clashes' },
];
